export default "__VITE_ASSET__BIO4Lxki__"